import classNames from 'classnames'
import PropTypes from 'prop-types'

const FilterButton = ({ onClick, text, isActive = false }) => (
  <button onClick={onClick} className={classNames('subHeaderTab', { active: isActive })}>
    {text}
  </button>
)

FilterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
}

export default FilterButton
